import axios from 'axios';
const dotenv = require('dotenv');
dotenv.config();
class ApiService {

  constructor() {
    this.baseApi = process.env.REACT_APP_API_URL;
    this.auth = {
      username: process.env.REACT_APP_USER,
      password: process.env.REACT_APP_PASS,
    }
  }

  timeout = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  findIp = async () => {
    try {
      let ip = '';
      try {
        ip = await axios.get(`https://api.ipify.org?format=json`, {});
        ip = ip.data.ip;
        if (ip === undefined) {
          throw new Error('IP cannot be null.');
        }
      } catch (e) {
        ip = '0.0.0.0';
      }
      return `-router:${ ip }`.replace(' ', '').toLocaleLowerCase();
    } catch(e) {
      // console.log(e);
      return undefined;
    }
  }

  getAllCandidates = async () => {
    try {
      // console.log(`${this.baseApi}/presi`);
      return await axios.get(`${this.baseApi}/presi`, {});
    } catch(e) {
      // console.log(e);
      return undefined;
    }
  }

  vote = async (presiId, machineIp) => {
    try {
      console.log('We have closed the voting!');
      // console.log(`${this.baseApi}/presi`);
      return null;
      // return await axios.post(`${this.baseApi}/vote`, {candidateId: presiId, machineIp: machineIp}, {auth: this.auth});
    } catch(e) {
      // console.log(e);
      return undefined;
    }
  }
  

  getVotes = async (candidateId) => {
    try {
      return await axios.post(`${this.baseApi}/vote/public/candidates`, {candidateId: candidateId});
    } catch(e) {
      return undefined;
    }
  }

  getStatistics = async () => {
    try {
      return await axios.get(`${this.baseApi}/vote/statistics`, {auth: this.auth});
    } catch(e) {
      return undefined;
    }
  }

  sendCode = async (msisdn) => {
    return await axios.post(`${this.baseApi}/vote/send-code`, {msisdn: msisdn}, {auth: this.auth});
  }

  checkCode = async (msisdn, code) => {
    return await axios.post(`${this.baseApi}/vote/check-code`, {msisdn: msisdn, code: code}, {auth: this.auth});
  }

  cancelCode = async (transId) => {
    return await axios.post(`${this.baseApi}/vote/cancel-code`, {transId: transId}, {auth: this.auth});
  }

  canVote = async (msisdn) => {
    return await axios.post(`${this.baseApi}/vote/can-vote`, {msisdn: msisdn}, {auth: this.auth});
  }
}

export default ApiService;